<template lang="html">
  <div class="notice_content">
    <div class="divider_line"><span>相关招股书</span></div>
    <div class="list_div">
        <Table
          :columns="columns"
          :data="list"
          v-if="list.length > 0">
        </Table>
        <!-- <div class="page clear" v-if="total > 10">
            <Page :total="total" :page-size="10" show-total class="page_list" @on-change="handlePage" show-elevator/>
        </div> -->
        <OrgPrompt which="zgsgs" v-if="list.length > 5"></OrgPrompt>
    </div>
    <Nothing v-if="list.length == 0 && !spinShow">
      <p>暂无相关招股书</p>
    </Nothing>
    <Spin fix v-if="spinShow">
        <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
        <div>Loading</div>
    </Spin>
  </div>
</template>

<script>
import { prospectusList } from '../../../service'
import filter from 'js/filter'
import Nothing from '@/components/Nothing2'
import OrgPrompt from '@/components/OrgPrompt'
import { get_meta } from 'js/get_meta'
export default {
  mixins: [get_meta],
  data() {
    return {
      spinShow: true,
      list: [],
      total: 0,
      params: {
        entity_uid: this.$route.params.uid,
      },
      columns: [
        {title: '发布时间',width: 210,render: (h, params) => {
            return h('span',filter.timeTrans(params.row.publish_time))
          }
        },
        {title: '招股书名称',Width: 390,render: (h, params) => {
            return h('div',{class: {vertical: true}},filter.empty(params.row.name))
          }
        },
        {title: '上市市场',width: 210,render: (h, params) => {
            return h('span',filter.empty(this.meta.zgs_market[params.row.market]))
          }
        },
        {title: '文件',width: 150,render: (h, params) => {
          if (params.row.file_path) {
            return h('a', {
              attrs:{
                href: this.$store.state.static_pdf_url + params.row.file_path.substr(1),
                download: params.row.file_name,
                target: '_blank'
              },
              class: {upload_ico: true},
            }, [
              h('i', {class: {iconfont: true}, domProps: {innerHTML: '&#xe67d;'}}),
              h('span','下载')
            ])
          } else if(params.row.src_url) {
            return h('a', {
              attrs:{
                href: params.row.src_url,
                referrerpolicy: 'no-referrer',
                target: '_blank'
              },
              class: {upload_ico: true},
            }, [
              h('i', {class: {iconfont: true}, domProps: {innerHTML: '&#xe67d;'}}),
              h('span','下载')
            ])
          } else {
            return h('span', '暂无')
          }
        }}
      ]
    }
  },
  components: {
    Nothing, OrgPrompt
  },
  methods: {
    async getDetail() {
      let res = await prospectusList(this.params, (error) => {
        this.$Message.error('请求错误！')
      })
      if(res.status == 'success') {
        this.$set(this.$data, 'list', res.res)
        if(this.list.length > 0) this.$emit('callbackData', 'Prospectus')
        this.spinShow = false;
      } else {
        this.$Message.error(res.msg)
      }
      this.$nextTick(() => {this.spinShow = false})
    },
    handlePage(page) {
      this.params.page = page
      this.getDetail()
    }
  },
  created() {
    this.getMeta(['zgs_market'])
    this.getDetail()
  }
}
</script>

<style lang="stylus" scoped>
@import '~styles/common.stylus'
.notice_content
  padding: 32px
  .divider_line
    margin: 0 0 32px
  .list_div
    padding: 0 18px
.ivu-table-wrapper >>> a.upload_ico
  color: rgba(250, 122, 80, 1)
  .iconfont
    display: inline-table
    vertical-align: top
    font-size: 14px
    margin-right: 4px
</style>
